export default {
  no_data: 'No data available!',
  popup_delay: 1000,
  WIZARD_INDICATORS : 'indicator',
  WIZARD_DATA_SOURCE: 'data_sources',
  WIZARD_MEA: 'mea',
  popup: { duration: '5000' },

  message: {
    create: {
      success: 'Item successfully created',
      failed: 'Item not created. Please try again later',
      error: 'An error occured while trying to create item.',
    },
    update: {
      success: 'Item successfully updated',
      failed: 'Update failed. Please try again later',
      error: 'An error occured while performing update request.',
      action: 'The action can not be undone. Are you sure you want to update?',
    },
    delete: {      
      success: 'Item successfully deleted',
      failed: 'Failed to delete selected item. No changes have been made',
      error: 'An error occured while performing delete operation.',
      action: 'This action can not be undone. Are you sure you want to delete? ',
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants.js